import React, { useCallback, useState } from 'react';
import { Button, ModalBase } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import modalContainer from 'packages/common/modalContainer';
import { useDeferredClose } from '~/hooks/useDeferredClose';

export const useValidationModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [shouldRender, onCloseAnimationEnd] = useDeferredClose(isOpen);
    const [errorType, setErrorType] = useState('generic');
    const { translate } = useTranslate();

    const toggleValidationModal = useCallback(
        (value: boolean, errorType = '') => {
            if (errorType) {
                setErrorType(errorType);
            }

            setIsOpen(value);
        },
        [setErrorType, setIsOpen],
    );

    const renderValidationModal = () => (
        <ModalBase
            container={modalContainer}
            isOpen={isOpen}
            onCloseAnimationEnd={onCloseAnimationEnd}
            onClose={() => {
                if (!shouldRender) {
                    return null;
                }

                toggleValidationModal(false);
            }}
        >
            <ModalBase.Header title={translate(`modal.assetsPicker.validationModal.title.${errorType}`)} />

            <ModalBase.Content>
                {translate(`modal.assetsPicker.validationModal.description.${errorType}`)}
            </ModalBase.Content>

            <ModalBase.Footer
                actionPrimary={
                    <Button
                        variant="primary"
                        onClick={() => {
                            toggleValidationModal(false);
                        }}
                    >
                        {translate('modal.assetsPicker.validationModal.button')}
                    </Button>
                }
            />
        </ModalBase>
    );

    return { toggleValidationModal, renderValidationModal };
};
